var baseClone=require("./_baseClone"),CLONE_SYMBOLS_FLAG=4;function clone(e){return baseClone(e,CLONE_SYMBOLS_FLAG)}module.exports=clone;